(function () {
	function swiperInit() {
      if (
        document.querySelectorAll(".js-media-list-loop") &&
        document.querySelectorAll(".js-media-list-loop").length > 0
      ) {
        document.querySelectorAll(".js-media-list-loop").forEach((elem, index) => {
          let slider = new Swiper(elem, {
            slidesPerView: 1,
            //autoHeight: true,
            spaceBetween: 24,
            navigation: {
              nextEl: ".swiper-btn--next",
              prevEl: ".swiper-btn--prev",
            },
            on: {
              slideChange: function () {
                window.pauseAllMedia();
                this.params.noSwiping = false;
              },
              slideChangeTransitionEnd: function () {
                if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                  this.slides[this.activeIndex]
                    .querySelector(".shopify-model-viewer-ui__button--poster")
                    .removeAttribute("hidden");
                }
              },
              touchStart: function () {
                if (this.slides[this.activeIndex].querySelector("model-viewer")) {
                  if (
                    !this.slides[this.activeIndex]
                      .querySelector("model-viewer")
                      .classList.contains("shopify-model-viewer-ui__disabled")
                  ) {
                    this.params.noSwiping = true;
                    this.params.noSwipingClass = "swiper-slide";
                  } else {
                    this.params.noSwiping = false;
                  }
                }
              },
            },
          });
        });
      }
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	swiperInit();
})();
